import { Link } from 'react-router-dom';
import { useState } from "react";
import logo from '../../../assets/images/resources/logo.png';

const MobileNav = ({ isSidebar, handleMobileMenu, handleSidebar }) => {
  const [isActive, setIsActive] = useState({
    status: false,
    key: "",
    subMenuKey: "",
  });

  const handleToggle = (key, subMenuKey = "") => {
    if (isActive.key === key && isActive.subMenuKey === subMenuKey) {
      setIsActive({
        status: false,
        key: "",
        subMenuKey: "",
      });
    } else {
      setIsActive({
        status: true,
        key,
        subMenuKey,
      });
    }
  };

  return (
    <>
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
        />
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
          >
            <i className="fa fa-times" />
          </span>
          <div className="logo-box">
            <Link to="/" aria-label="logo image">
              <img src={logo} width="150" alt="Logo" />
            </Link>
          </div>
          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li className={isActive.key === "home" ? "dropdown current" : "dropdown"}>
                <Link to="/" onClick={handleMobileMenu}>Home</Link>
              </li>
              <li><Link to="/about" onClick={handleMobileMenu}>About Us</Link></li>
              <li className={isActive.key === "pages" ? "dropdown current" : "dropdown"}>
                <Link to="#" onClick={() => handleToggle("pages")}>Services</Link>
                <ul style={{ display: `${isActive.key === "pages" ? "block" : "none"}` }}>
                  <li><Link to="/security-consulting" onClick={handleMobileMenu}>Security Consulting</Link>
                  <ul style={{ display: `${isActive.key === "projects" ? "block" : "none"}` }}>
                  <li><Link to="/project" onClick={handleMobileMenu}>Projects</Link></li>
                </ul>
                <div className={isActive.key === "projects" ? "dropdown-btn open" : "dropdown-btn"} onClick={() => handleToggle("projects")}>
                  <span className="fa fa-angle-right" />
                </div>
                  </li>
                  <li><Link to="/audit-&-compliance" onClick={handleMobileMenu}>Audit Complinace</Link></li>
                  <li><Link to="/cloud-security" onClick={handleMobileMenu}>Cloud Security</Link></li>
                  <li><Link to="/network-security" onClick={handleMobileMenu}>Network Security</Link></li>
                  <li><Link to="/design-&-implementation" onClick={handleMobileMenu}>Design Implementation</Link></li>
                  <li><Link to="/managed-it-services" onClick={handleMobileMenu}>Managed IT Services</Link></li>
                  <li><Link to="/ot-iot-security" onClick={handleMobileMenu}>OT, IOT Security</Link></li>
                  <li><Link to="/api-security" onClick={handleMobileMenu}>API Security</Link></li>
                  <li><Link to="/offensive-security-red-teaming" onClick={handleMobileMenu}>Offensive Security, Red Teaming</Link></li>
                  <li><Link to="/vulnerability-assessment" onClick={handleMobileMenu}>Vulnerability Assessment</Link></li>
                </ul>
                <div className={isActive.key === "pages" ? "dropdown-btn open" : "dropdown-btn"} onClick={() => handleToggle("pages")}>
                  <span className="fa fa-angle-right" />
                </div>
              </li>
              <li className={isActive.key === "services" ? "dropdown current" : "dropdown"}>
                <Link to="/news-events" onClick={() => handleToggle("services")}>News & Events</Link>
              </li>
              <li className={isActive.key === "projects" ? "dropdown current" : "dropdown"}>
                <Link to="/careers" onClick={() => handleToggle("projects")}>Careers</Link>
              </li>
              <li><Link to="/contact" onClick={handleMobileMenu}>Contact Us</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
